import { faEye, faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Table, Badge } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as Common from '../Common';
import Dialog from '../Dialog';
import Loginheader from '../Loginheader';
import Menu from '../Menu';



function BookingModule() {
    const navigate = useNavigate();
    const now = new Date();
    // Extracting date parts
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, '0');
    let day = String(now.getDate()).padStart(2, '0');

    // Extracting time parts
    let hours = String(now.getHours()).padStart(2, '0');
    let minutes = String(now.getMinutes()).padStart(2, '0');
    let seconds = String(now.getSeconds()).padStart(2, '0');

    // Constructing the final formatted date-time string
    let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const sid = sessionStorage.getItem('sessionId');
    const [entityType, setEntityType] = useState("A");
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [enqBran, setEnqBran] = useState("0");
    const [enqBranName, setEnqBranName] = useState("0");
    const [enqBranSelect, setEnqBranSelect] = useState({ label: 'Select', value: '0' });
    const [loanAccNo, setLoanAccNo] = useState("");
    const [panNo, setPanNo] = useState("");
    const [reqIsd, setReqIsd] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [reqQuantity, setReqQuantity] = useState("");
    const [saleRate, setSaleRate] = useState("");
    const [radioType, setRadioType] = useState("L");
    const [scrMode, setScrMode] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [paymentMode, setPaymentMode] = useState("");
    const [referenceNo, setReferenceNo] = useState("");
    const [amount, setAmount] = useState(0);
    const [ddReqBranOptions, setDdReqBranOptions] = useState([]);
    const [enqName, setEnqName] = useState("");
    const [entityId, setEntityId] = useState("");
    const [showCalculations, setShowCalculations] = useState(false);
    const [docListData, setDocListData] = useState([]);
    const [gst, setGst] = useState(0);
    const [serviceCharge, setServiceCharge] = useState(0);
    const [handlingCharges, setHandlingCharges] = useState(0);
    const [nostroCharges, setNostroCharges] = useState(0);
    const [tcs, setTcs] = useState(0);
    const [totalinr, setTotalinr] = useState(0);
    const [forexAmount, setForexAmount] = useState(0);
    const [charges, setCharges] = useState(0);
    const [roundOff, setRoundOff] = useState(0);
    const [earlierForex, setEarlierForex] = useState(0);

    const [randomString, setRandomString] = useState("");
    const fileInputRef = useRef(null);
    const [reqAgent, setReqAgent] = useState("0");
    const [reqAgentName, setReqAgentName] = useState("");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [enqDocRemark, setEnqDocRemark] = useState("");
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);
    const [bookingListData, setBookingListData] = useState([]);
    const [hdrSrno, setHdrsno] = useState(0);
    const [bookingStatus, setBookingStatus] = useState("");
    const [zenithRate, setZenithRate] = useState(0);
    const [srchToDate, setSrchToDate] = useState(new Date());
    const [srchFromDate, setSrchFromDate] = useState(new Date("2024-01-01"));
    const [srchLoanAccNo, setSrchLoanAccNo] = useState("");
    const [srchPanNo, setSrchPanNo] = useState("");
    const [srchStatus, setSrchStatus] = useState("All");

    const [userApproverRight, setUserApproverRight] = useState([]);
    const [comment, setComment] = useState("");
    const [commentData, setCommentData] = useState([]);
    const [logData, setLogData] = useState([]);
    const [allowedAgent, setAllowedAgent] = useState([]);
    const [enqMargin, setEnqMargin] = useState(0);
    const [ibr, setIbr] = useState(0);
    const [totalTaxable, setTotalTaxable] = useState(0);
    const [bankCharges, setBankCharges] = useState(0);
    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'BOOKINGMODULE'], function (result) {
                let resp = JSON.parse(result);
                setUserRight(resp);
                if (resp.query === "0") {
                    navigate("/");
                }

                setEntityId(sessionStorage.entityId);
                setEntityType(sessionStorage.entityType);
                Common.callApi(Common.apiUser, [sid, 'branchallactiveselect'], function (result) {
                    let resp = JSON.parse(result);
                    setDdReqBranOptions(resp);
                });
                Common.callApi(Common.apiIsd, [sid, 'ddlistjson'], function (result) {
                    setDdReqIsdOptions(JSON.parse(result));
                });
                if (sessionStorage.entityType === "A") {
                    setDdReqAgentOptions([{ label: sessionStorage.entityname, value: sessionStorage.entityId }]);
                    onChangeAgent(sessionStorage.entityId, sessionStorage.entityname);
                }
                if (sessionStorage.entityType === "B") {
                    Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqAgentOptions(resp);
                        const allowedAgentArray = resp.map((res) => res.value);
                        setAllowedAgent(allowedAgentArray);
                    });
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'BOOKINGMODULEAPPROVER'], function (result) {
                let resp = JSON.parse(result);
                setUserApproverRight(resp);
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, ddReqAgentOptions]);

    function saveData() {
        $('.loader').show();
        var msg = [], i = 0;
        if (loanAccNo === "" || panNo === "" || reqIsd === "0" || reqQuantity === "" || saleRate === ""
            || reqAgent === "0" || enqBran === "0" || (paymentMode === "Ac" && referenceNo === "" && amount === 0)
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (loanAccNo === "" ? " LoanAccNo " : '');
            msg[i++] = (panNo === "" ? " PanNo " : '');
            msg[i++] = (reqIsd === "0" ? " Isd " : '');
            msg[i++] = (reqQuantity === "" ? " Quantity " : '');
            msg[i++] = (saleRate === "" ? " SaleRate " : '');
            msg[i++] = (enqBran === "0" ? " Zenith Location " : '');
            msg[i++] = (reqAgent === "0" ? " Agent " : '');
            msg[i++] = ((paymentMode === "Ac" && referenceNo === "") ? " Refrence No " : '');
            msg[i++] = ((paymentMode === "Ac" && amount === 0) ? " Amount " : '');
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            var obj = {
                hdrsrno: hdrSrno,
                uniquekey: randomString,
                enqBran: enqBran,
                enqName: "",
                enqAgentName: reqAgentName,
                reqQty: (reqQuantity.trim() === "" ? 0 : reqQuantity),
                reqAgent: reqAgent,
                lan: loanAccNo,
                pan: panNo,
                ISD: reqIsd,
                quantity: reqQuantity,
                salerate: saleRate,
                commentdata: commentData,
                paymentMode: paymentMode,
                referenceNo: referenceNo,
                amount: amount,
                forexamount: forexAmount,
                fromdate: Common.dateYMD(srchFromDate),
                todate: Common.dateYMD(srchToDate),
                filterpan: srchPanNo,
                filterlan: srchLoanAccNo,
                filterStatus: srchStatus,
                servicecharge: serviceCharge,
                gst: gst,
                tcs: tcs,
                nostrocharges: nostroCharges,
                bankcharges: bankCharges,
                handlingcharge: handlingCharges,
                totalinr: totalinr,
                zenithrate: (zenithRate === "" ? 0 : zenithRate),
                totalcharges: charges,
                roundoff: roundOff,
                earlierForex: earlierForex,
                allowedagent: allowedAgent,
                margin: enqMargin,
                ibr: ibr,
                totaltaxable: totalTaxable,
            }
            console.log(obj);
            Common.callApi(Common.apiBooking, [sid, 'save', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    // addNewForm();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    setScrMode("");
                    setDocListData([]);
                    setBookingListData(resp.bookinglist);
                    setCommentData([]);
                    setLogData([]);
                    // setBookingListData([])
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                    // setDocListData([]);
                    //  setBookingListData(resp.bookinglist)
                }

            })
        }
    }
    function onChangeAgent(id, agnname) {
        setReqAgent(id);
        setReqAgentName(agnname);
    }

    const addNewForm = () => {
        const randomStr = Math.random().toString(36).substring(2, 10);
        setHdrsno(0);
        setRandomString(randomStr);
        setLoanAccNo("");
        setPanNo("");
        setReqQuantity("");
        setSaleRate("");
        setPaymentMode("");
        setReferenceNo("");
        setAmount(0);
        setEnqBranSelect("{label: 'Select', value: '0'}");
        setScrMode("A");
        setDocListData([]);
        setEnqBran("0");
        setReqIsd("0");
        setShowCalculations(false);
        // setDdReqIsdOptions([]);
        if (sessionStorage.entityType === "B") {
            setReqAgent("");
        }
        setEnqDocRemark("");
        setZenithRate("");
        setCommentData([]);
        setLogData([]);
    }

    const listBooking = () => {
        $('.loader').show();
        var msg = [], i = 0;
        var obj = {
            sid: sid,
            fromdate: Common.dateYMD(srchFromDate),
            todate: Common.dateYMD(srchToDate),
            filterpan: srchPanNo,
            filterlan: srchLoanAccNo,
            filterStatus: srchStatus,
            reqAgent: reqAgent,
            allowedagent: allowedAgent,
        };
        Common.callApi(Common.apiBooking, [sid, 'getBookingList', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);

            if (resp.length === 0) {
                msg[i++] = ("Data not Available");
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            } else {
                setBookingListData(resp);
            }
            $('.loader').hide();
        });

    };

    function btnUploadFile() {
        $('.loader').show();
        var msg = [], i = 0;
        if ((fileInputRef === null || enqDocRemark === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((fileInputRef === null && enqDocRemark !== "") ? "Select the File to Upload" : '');
            msg[i++] = ((fileInputRef !== null && enqDocRemark === "") ? "Enter the Remark" : '');
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            if (document.getElementById('fileToUpload').files[0] === undefined) {
                $('.loader').hide();
                setMsgText("Please select a file to upload.");
                setMsgBox(true);
            } else {
                var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');

                if (tempArray.length > 2) {
                    $('.loader').hide();
                    setMsgText("(.) not allowed in file name.");
                    setMsgBox(true);
                } else if (document.getElementById('fileToUpload').files[0] === undefined) {

                } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                    $('.loader').hide();
                    setMsgText("Please select a file with in 10 MB size.");
                    setMsgBox(true);
                } else {
                    var object1 = {
                        hdrsrno: hdrSrno,
                        uniquekey: randomString,
                        sid: sid,
                        uploadType: 'BOOKING',
                        srno: 0,
                        pageright: 'BOOKINGMODULE',
                        docid: "0",
                        remark: enqDocRemark,
                    }
                    $('.loader').hide();
                    Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                        let resp = JSON.parse(result);
                        $('.loader').hide();
                        if (resp.error === "") {
                            setDocListData(resp.docdetail);
                            alert(resp.message);
                            setEnqDocRemark("");

                        }
                        if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                        }
                    });
                }
            }
        }
    }
    function handleCalculate() {

        var msg = [], i = 0;
        if ((reqQuantity === "" || saleRate === "" || panNo === "" || reqIsd === "") || (saleRate * 1) < (zenithRate * 1)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (saleRate === "" ? "Sale Rate" : '');
            msg[i++] = (reqQuantity === "" ? "Quantity" : '');
            msg[i++] = (panNo === "" ? "Pan No " : '');
            msg[i++] = (reqIsd === "" ? "ISD " : '');
            msg[i++] = ((saleRate * 1) < (zenithRate * 1) ? "Sale rate should be greater than Zenith Rate " : '');
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $('.loader').show();
            var obj = {
                entityId: parseInt(entityId, 10),
                reqAgent: reqAgent,
                quantity: reqQuantity,
                salerate: saleRate,
                remitterpan: panNo,
                isd: reqIsd,
                agentcode: reqAgent,


            }
            Common.callApi(Common.apiBooking, [sid, 'getServiceCharge', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                console.log(resp);
                setReqQuantity(resp.quantity);
                setSaleRate(resp.sellrate);
                setServiceCharge(resp.servicecharge);
                setForexAmount(resp.forex);
                setCharges(resp.charges);
                setGst(resp.gst);
                setTcs(resp.tcs);
                setRoundOff(resp.roundoff);
                setEarlierForex(resp.earlierforex);
                setTotalinr(resp.totalinr);
                setZenithRate(resp.zenithrate);
                setHandlingCharges(resp.handlingCharges);
                setNostroCharges(resp.nostroCharges);
                setEnqMargin(resp.margin);
                setIbr(resp.ibr);
                setTotalTaxable(resp.totalTaxable);
                setBankCharges(resp.bankcharges);
                $('.loader').hide();
                setShowCalculations(true);
            })
        }
    }
    function resetCalculation() {
        if (sessionStorage.entityType === "B") {
            setReqAgent("");
        }
        setLoanAccNo(loanAccNo);
        setPanNo(panNo);
        setReqIsd(reqIsd);
        console.log("this ie me ", enqBran, reqAgentName)
        setEnqBranSelect({ value: enqBran, label: enqBranName });
        setEnqBran(enqBran);
        setReqQuantity(reqQuantity);
        setSaleRate(saleRate);
        setReqAgentName(reqAgentName);
        setReqAgent(reqAgent);
        // setDdReqIsdOptions([]);
        setShowCalculations(false);

    }
    function getDetails(hdrSrno) {
        Common.callApi(Common.apiBooking, [sid, 'detail', hdrSrno], function (result) {
            let resp = JSON.parse(result);
            setCommentData(resp.comment);
            setLogData(resp.log);
        });
    }
    function btnAddComment() {
        if (hdrSrno === 0) {
            var object1 = {
                ecmnt_lineno: hdrSrno,
                ecmnt_desc: comment,
                um_username: " ",
                ecmnt_createdatstamp: formattedDate
            }
            var commentlist = Common.arrayAddItem(commentData, object1);
            setCommentData([...commentlist]);
            setComment("");
        } else {
            $('.loader').show();
            var object1 = {
                hdrSrno: hdrSrno,
                ecmnt_lineno: hdrSrno,
                ecmnt_desc: comment,
                um_username: " ",
                ecmnt_createdatstamp: formattedDate
            }
            Common.callApi(Common.apiBooking, [sid, 'addsinglecomment', JSON.stringify(object1)], function (result) {
                $('.loader').hide();
                let resp = JSON.parse(result);
                console.log(result);

                if (resp.err === "") {
                    setCommentData(resp.comment);
                    setComment("");
                    //    setMsgText(resp.msg);
                    //    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }


            });
        }


    }

    function handleReqBranchOptions(v) {
        console.log("requested branch", v)
        setEnqBranSelect(v);
        setEnqBran(v.value);
        setEnqBranName(v.label);
    }
    function btnDocumentView(srno, filename, uniqueKey, lineNo) {
        var obj = {
            hdrsrno: hdrSrno,
            srno: srno,
            lineno: lineNo,
            filename: filename,
            uniquekey: uniqueKey
        }
        Common.callDocumentViewApi(Common.apiBooking, [sid, 'docview', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }
    function btnDocumentDownload(srno, filename, uniqueKey, lineNo) {
        var object1 = {
            hdrsrno: hdrSrno,
            srno: srno,
            lineno: lineNo,
            filename: filename,
            uniquekey: uniqueKey
        }
        Common.callDownloadApiPost(Common.apiBooking, "post", [sid, 'docdownload', JSON.stringify(object1)]);

    }
    const deleteDocument = (uniqueKey, srno, filename) => {
        $('.loader').show();
        var obj = {
            hdrsrno: hdrSrno,
            uniquekey: uniqueKey,
            srno: srno,
            filename: filename
        }
        Common.callApi(Common.apiBooking, [sid, 'deletefile', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            if (resp.result === true) {
                setDocListData(resp.docdetail);

            }
            $('.loader').hide();
        })

    }
    const handleBookingView = (uniquekey, srno) => {
        var obj = {
            uniquekey: uniquekey,
            hdrSrno: srno,

        };
        Common.callApi(Common.apiBooking, [sid, 'getBookingData', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            setCharges(resp.data[0].enq_othercharges);
            setRoundOff(resp.data[0].enq_roundoff);
            setEarlierForex(resp.data[0].enq_earlierforex);
            setScrMode('Q');
            getDetails(resp.data[0].enq_srno);
            setBookingStatus(resp.data[0].enq_booking_status);
            setRandomString(uniquekey);
            setHdrsno(resp.data[0].enq_srno);
            setLoanAccNo(resp.data[0].enq_loanacctno);
            setPanNo(resp.data[0].enq_pancard);
            setReqQuantity(resp.data[0].enq_quantity);
            setSaleRate(resp.data[0].enq_sellrate);
            setPaymentMode(resp.data[0].enq_payment_type);
            setReferenceNo(resp.data[0].enq_refno);
            setAmount(resp.data[0].enq_amount);
            setEnqBranSelect({ value: resp.data[0].enq_branch, label: resp.data[0].enq_agentname });
            setDocListData(resp.docData);
            setEnqBran(resp.data[0].enq_branch);
            setReqIsd(resp.data[0].enq_isd);
            setReqAgent(resp.data[0].enq_agentcode);
            // setEnqDocRemark(resp.data[0].enq_quantity);
            setServiceCharge(resp.data[0].enq_othercharges);
            setGst(resp.data[0].enq_gst);
            setTcs(resp.data[0].enq_tcs);
            setHandlingCharges(resp.data[0].enq_handlingcharges);
            setNostroCharges(resp.data[0].enq_nostrocharges);
            setTotalinr(resp.data[0].enq_total_inr);
            setZenithRate(resp.data[0].enq_zenithrate);
            setForexAmount(resp.data[0].enq_forexamt);
            setBankCharges(resp.data[0].enq_bankcharges);
            $('.loader').hide();
            setShowCalculations(true);

        })


    };
    const UpdateStatus = (updatedStatus) => {
        $('.loader').show();
        var obj = {
            hdrsrno: hdrSrno,
            bookingStatus: updatedStatus,
            uniquekey: randomString,
            fromdate: Common.dateYMD(srchFromDate),
            todate: Common.dateYMD(srchToDate),
            filterpan: srchPanNo,
            filterlan: srchLoanAccNo,
            filterStatus: srchStatus,
            commentdata: commentData,
            isd: reqIsd,
            agentcode: reqAgent,
            allowedagent: allowedAgent,
        };
        Common.callApi(Common.apiBooking, [sid, 'UpdateBookingStatus', JSON.stringify(obj)], function (result) {
            $('.loader').hide();
            let resp = JSON.parse(result);

            $('.loader').hide();
            setBookingStatus(resp.result);
            if (resp.err === "A") {
                setMsgText("Successfully Approved");
                setMsgBox(true);
                setScrMode("");
            } else if (resp.err === "R") {
                setMsgText("Successfully Rejected");
                setMsgBox(true);
                setScrMode("");
            } else if (resp.err === "U") {
                setMsgText("Sent For Correction ");
                setMsgBox(true);
                setScrMode("");
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setBookingListData(resp.bookinglist);
        })
        setScrMode("");

    }
    function btnBackClick() {
        setScrMode("");
    }
    function btnEditRequest() {
        setScrMode("E");

    }

    function refreshZenithRate(v) {
        var msg = [], i = 0;
        if ((v === "" || v === "0")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (v === "" || v === "0" ? "ISD " : '');
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $('.loader').show();
            var obj = {
                entityId: parseInt(entityId, 10),
                reqAgent: reqAgent,
                quantity: 1,
                salerate: 1,
                remitterpan: 'AAAAA0000A',
                isd: v,
                agentcode: reqAgent,
            }
            Common.callApi(Common.apiBooking, [sid, 'getServiceCharge', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                console.log(resp);
                setZenithRate(resp.zenithrate);
                $('.loader').hide();
            })
        }
    }

    function onCurrencyChange(v) {
        setReqIsd(v);
        if (v === "" || v === "0") {
            setZenithRate("0");
        } else {
            refreshZenithRate(v);
        }
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h1>Booking Module</h1>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Row>
                                    <Col className='col-md-4 col-6'>
                                        <Form.Group>
                                            <Row style={{ marginTop: "30px" }}>
                                                <Col style={{ display: "flex" }}>

                                                    <Form.Check checked={radioType === "L"} onChange={() => setRadioType("L")} type='radio' label="List" />&nbsp;
                                                    {userRight.add === "1" ? <>
                                                        <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />&nbsp;
                                                    </> : null}
                                                </Col>
                                            </Row>
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Row>
                            <br />
                            {radioType === 'L' ?
                                <Row>
                                    <Col className='col-md-2 col-2'>
                                        <Form.Group>
                                            <Form.Label>From Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={srchFromDate}
                                                onChange={(date) => setSrchFromDate(date)}
                                                // isClearable
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-2 col-2'>
                                        <Form.Group>
                                            <Form.Label>To Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={srchToDate}
                                                onChange={(date) => setSrchToDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-2 col-2'>
                                        <Form.Group>
                                            <Form.Label>Status: </Form.Label>
                                            <Form.Select value={srchStatus} onChange={(e) => setSrchStatus(e.target.value)}>
                                                <option value="All">All</option>
                                                <option value="A">Approved</option>
                                                <option value="P">Pending</option>
                                                <option value="R">Rejected</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Row>
                                        <Col className='col-md-2 col-2'>
                                            <Form.Group >
                                                <Form.Label>PAN<span className="mandatory"></span></Form.Label>
                                                <Form.Control type="text" placeholder="PAN" maxLength={10}
                                                    value={srchPanNo} onChange={(e) => setSrchPanNo(e.target.value.toUpperCase())} autoComplete="off"
                                                    onBlur={(e) => Common.validatePan(e.target.value, setSrchPanNo)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-2 col-2' >
                                            <Form.Group >
                                                <Form.Label>LAN<span className="mandatory"></span></Form.Label>
                                                <Form.Control type="text" placeholder="LAN" maxLength={20}
                                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setSrchLoanAccNo)}
                                                    value={srchLoanAccNo} autoComplete="off"
                                                />
                                            </Form.Group>
                                        </Col>

                                    </Row>

                                </Row> : null}
                            <Row>
                                <Row>&nbsp;</Row>
                                <Col>
                                    {
                                        userRight.query === "1" && radioType === "L" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listBooking()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }
                                    &nbsp;
                                </Col>
                            </Row>
                            <br />

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>
                                        {/* <td>Sr No</td> */}
                                        <td>Reference</td>
                                        <td>DateTime</td>
                                        <td>Branch</td>
                                        <td>LAN</td>
                                        <td>PAN</td>
                                        <td>ISD</td>
                                        <td>Quantity</td>
                                        <td>Status</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bookingListData.map((res) =>
                                        <tr key={res.doc_filename}>
                                            <td>
                                                {

                                                    <span onClick={() => handleBookingView(res.enq_uniquekey, res.enq_srno)} className='colorThemeBlue pointer'>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>

                                                }
                                            </td>

                                            {/* <td>{res.enq_srno}</td> */}
                                            <td>{res.enq_refno}</td>
                                            <td>{res.enq_timestampdmy}</td>
                                            <td>{res.enq_branchname}</td>
                                            <td>{res.enq_loanacctno}</td>
                                            <td>{res.enq_pancard}</td>
                                            <td>{res.enq_isd}</td>
                                            <td>{res.enq_quantity}</td>
                                            <td>{res.enq_booking_status === "P" ? "Pending" : res.enq_booking_status === "A" ? "Approved" : res.enq_booking_status === "U" ? "Unlocked" : "Rejected"}</td>

                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </> :
                        <>

                            <Row>
                                <Col>

                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => btnBackClick()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q' && bookingStatus === 'U') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    &nbsp;
                                    {
                                        (showCalculations === true) && ((userRight.edit === "1" && scrMode === 'E' && bookingStatus === 'U') || (userRight.add === "1" && scrMode === 'A')) ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    &nbsp;
                                    {/*
                                    {
                                        (showCalculations === true) && ((userRight.edit === "1" && scrMode === 'E' && bookingStatus === 'U') || (userRight.add === "1" && scrMode === 'A')) ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    } */}

                                    {
                                        userApproverRight.query === "1" &&
                                        <>
                                            {
                                                scrMode === 'Q' && bookingStatus === "P" ?
                                                    <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => UpdateStatus("A")}>Approve</Button>&nbsp;
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => UpdateStatus("R")}>Reject</Button>&nbsp;
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => UpdateStatus("U")}>Unlock</Button>&nbsp;
                                                    </> : null
                                            }
                                        </>
                                    }



                                </Col>
                            </Row>
                            <Row>
                                {scrMode === "Q" ?
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Label>Sr No : {hdrSrno}</Form.Label>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Label>Booking Status : {bookingStatus === 'A' ? "Approved" : bookingStatus === 'R' ? "Rejected" : bookingStatus === 'U' ? "Unlock" : "Pending"}</Form.Label>
                                        </Col>
                                    </Row> : null}
                                <Col className='col-md-3 col-4'>
                                    <Form.Group>
                                        <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            value={reqAgent}
                                            onChange={(e) => onChangeAgent(e.target.value, e.target[e.target.selectedIndex].text)}
                                            disabled={entityType === 'A' || scrMode === 'Q' || showCalculations === true}
                                        >
                                            {ddReqAgentOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.label}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col className='col-md-3 col-4'>
                                    <Form.Group>
                                        <Form.Label>Zenith Location<span className="mandatory">*</span></Form.Label>
                                        <Select
                                            value={enqBranSelect}
                                            onChange={handleReqBranchOptions}
                                            options={ddReqBranOptions}
                                            isDisabled={scrMode === 'Q' || showCalculations === true}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col className='col-md-3 col-4' >
                                    <Form.Group >
                                        <Form.Label>LAN<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="LAN" maxLength={20}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setLoanAccNo)}
                                            value={loanAccNo} autoComplete="off"
                                            disabled={scrMode === 'Q' || showCalculations === true} />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-4'>
                                    <Form.Group >
                                        <Form.Label>PAN<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="PAN" maxLength={10}
                                            value={panNo} onChange={(e) => setPanNo(e.target.value.toUpperCase())} autoComplete="off"
                                            onBlur={(e) => Common.validatePan(e.target.value, setPanNo)}
                                            disabled={scrMode === 'Q' || showCalculations === true} />



                                    </Form.Group>
                                </Col>


                                <Col className='col-md-3 col-4'>
                                    <Form.Group>
                                        <Form.Label>Currency<span className="mandatory">*</span></Form.Label>
                                        <Select
                                            value={ddReqIsdOptions.find(option => option.value === reqIsd)}
                                            onChange={(selectedOption) => onCurrencyChange(selectedOption.value)}
                                            options={ddReqIsdOptions}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.value}
                                            isSearchable={true}  // Make the dropdown searchable
                                            isDisabled={scrMode === 'Q' || showCalculations === true}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-4'>
                                    <Form.Group >
                                        <Form.Label>Zenith Rate
                                            {
                                                scrMode !== 'Q' ? <>
                                                    <span onClick={() => refreshZenithRate(reqIsd)} >&nbsp;&nbsp;<Badge bg="primary">Refresh</Badge></span>
                                                </> : null
                                            }
                                        </Form.Label>
                                        <Form.Control type="text"
                                            value={zenithRate} autoComplete="off"
                                            disabled />
                                    </Form.Group>
                                </Col >
                                <Col className='col-md-3 col-4'>

                                    <Form.Group >

                                        <Form.Label>Quantity<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                            onChange={(e) => { Common.validateDecValue(e.target.value, setReqQuantity); setShowCalculations(false) }}
                                            value={reqQuantity} autoComplete="off"
                                            disabled={scrMode === 'Q' || showCalculations === true} />
                                    </Form.Group>

                                </Col >
                                <Col className='col-md-3 col-4'>
                                    <Row>
                                        <Form.Group >
                                            <Form.Label>Sale Rate<span className="mandatory">*</span></Form.Label>
                                            {/* <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleCalculate}><Badge bg="secondary">Calculate</Badge></span> */}
                                            <Form.Control type="text" placeholder="SaleRate" maxLength={10}
                                                onChange={(e) => { Common.validateDecValue(e.target.value, setSaleRate); setShowCalculations(false) }}
                                                value={saleRate} autoComplete="off"
                                                disabled={scrMode === 'Q' || showCalculations === true} />
                                        </Form.Group>
                                    </Row>

                                </Col>
                                <Row>&nbsp;</Row>
                                {scrMode !== "Q" ?
                                    <Row>
                                        <Col className="col-md-3 col-3 d-flex">
                                            {showCalculations === false ? <Button variant='outline-success' size='sm' className='buttonStyle' style={{ borderRadius: '25px', }} onClick={() => handleCalculate()}>Calculate</Button>
                                                : < Button variant='outline-danger' size='sm' className='buttonStyle' style={{ borderRadius: '25px', }} onClick={resetCalculation}>Reset</Button>
                                            }
                                        </Col>
                                        <Col className='col-md-2 col-2'></Col>
                                    </Row> : null}
                                <Row>&nbsp;</Row>
                                {showCalculations ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Table responsive striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <td>Quantity</td>
                                                            <td>Rate</td>
                                                            <td>Forex</td>
                                                            <td>Charges</td>
                                                            <td>GST</td>
                                                            <td>TCS</td>
                                                            <td>RoundOff</td>
                                                            <td>NetAmount</td>
                                                            <td>Earlier Forex</td>
                                                            {
                                                                /*<td>Zenith Rate</td>*/
                                                            }

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{reqQuantity}</td>
                                                            <td>{saleRate}</td>
                                                            <td>{forexAmount}</td>
                                                            <td>{charges}</td>
                                                            <td>{gst}</td>
                                                            <td>{tcs}</td>
                                                            <td>{roundOff}</td>
                                                            <td>{totalinr}</td>
                                                            <td>{earlierForex}</td>
                                                            {/* <td>{zenithRate}</td> */}
                                                        </tr>


                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                    </> : null}
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    <h3>Upload Document </h3>
                                </Col>
                            </Row>
                            {(scrMode !== "Q") ?

                                <Row>
                                    <Col className='col-md-3 col-4 '>
                                        <Form.Group controlId='fileToUpload'>
                                            <Form.Label>File (Max 10MB)</Form.Label>
                                            <Form.Control type="file" ref={fileInputRef}
                                                disabled={scrMode === 'Q'}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-4'>
                                        <Form.Group >
                                            <Form.Label>Remark</Form.Label>
                                            <Form.Control as="textarea" rows={1} placeholder="Remark" maxLength={50} autoComplete="off"
                                                value={enqDocRemark}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setEnqDocRemark)}
                                                isDisabled={fileInputRef === null}
                                                disabled={scrMode === 'Q'}
                                            ></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>&nbsp;</Form.Label><br></br>
                                            <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile()} disabled={scrMode === 'Q'} >Upload</Button>
                                        </Form.Group>
                                    </Col>
                                    <Col>&nbsp;</Col><Col>&nbsp;</Col>
                                </Row>
                                : null}
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>

                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td>Remark</td>
                                                <td>File Name</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {docListData.map((res) =>
                                                <tr key={res.doc_filename}>
                                                    <td>
                                                        {

                                                            <span
                                                                onClick={() => deleteDocument(res.doc_uniquekey, res.doc_lineno, res.doc_filename)}
                                                                className='colorThemeBlue pointer'
                                                                style={{ display: scrMode === 'Q' ? 'none' : 'inline' }}  // Correct style usage
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </span>


                                                        }
                                                    </td>

                                                    <td className='divHide'>{res.doc_unique_key}</td>
                                                    <td>{res.doc_remark}</td>
                                                    <td>{res.doc_filename}</td>
                                                    <td>
                                                        <div className="colorThemeBlue">
                                                            {
                                                                (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                                    || res.doc_ext === "jpg" || res.doc_ext === "png") ? <>
                                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename, res.doc_uniquekey, res.doc_lineno)}>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>&nbsp;
                                                                </> : null
                                                            }

                                                            <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename, res.doc_uniquekey, res.doc_lineno)}>
                                                                <FontAwesomeIcon icon={faFileDownload} />
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <br />

                            <Row>
                                <Form.Group>
                                    <Form.Label><h3>Payment Type<span className="mandatory">*</span></h3></Form.Label>
                                    <Col className='col-md-3 col-4' >

                                        <Form.Select
                                            value={paymentMode}
                                            onChange={(e) => setPaymentMode(e.target.value)} disabled={scrMode === 'Q'}>
                                            <option value="Ad">Advance</option>
                                            <option value="Ac">Actual</option>

                                        </Form.Select>
                                    </Col>
                                </Form.Group>


                                {paymentMode === "Ac" ?
                                    <>
                                        <Col className='col-md-3 col-4'>
                                            <Form.Group >
                                                <Form.Label>Reference Number<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Reference Number" maxLength={255}
                                                    onChange={(e) => setReferenceNo(e.target.value)}
                                                    value={referenceNo} autoComplete="off"
                                                    disabled={scrMode === 'Q'} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-4'>
                                            <Form.Group >
                                                <Form.Label>Amount<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Amount" maxLength={10}
                                                    onChange={(e) => { Common.validateDecValue(e.target.value, setAmount); }}
                                                    value={amount} autoComplete="off"
                                                    disabled={scrMode === 'Q'} />
                                            </Form.Group>
                                        </Col>
                                        {/* <Row>&nbsp;</Row> */}

                                    </> : null}
                                {/* {((userRight.add === '1' && scrMode === " ") || (userRight.edit === "1" && scrMode === 'E' && bookingStatus === 'U') || (userApproverRight.query === "1")) ? */}
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group >
                                            <Form.Label>Comment</Form.Label>
                                            <Form.Control type="text" placeholder="Comment" maxLength={100}
                                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setComment)}
                                                value={comment} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>&nbsp;</Form.Label><br></br>
                                            <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {/* : null} */}
                                <Row>
                                    <Col>
                                        <h5>Comment Details</h5>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Table responsive striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <td>Timestamp</td>
                                                    <td>User</td>
                                                    <td>Comment</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    commentData.length > 0 ? <>
                                                        {
                                                            commentData.map((res) =>
                                                                <tr key={res.ecmnt_lineno} >
                                                                    <td>{res.ecmnt_createdatstamp}</td>
                                                                    <td>{res.um_username}</td>
                                                                    <td>{res.ecmnt_desc}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </> : null
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                            </Row>
                            <Row>
                                <Col>
                                    <h5>Log Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>Timestamp</td>
                                                <td>User</td>
                                                <td>Activity</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                logData.length > 0 ? <>
                                                    {
                                                        logData.map((res) =>
                                                            <tr key={res.enqlog_lineno} >
                                                                <td>{res.enqlog_logtimestamp}</td>
                                                                <td>{res.enqlog_user} {res.um_username}</td>
                                                                <td>{res.enqlog_rmk}</td>
                                                            </tr>
                                                        )
                                                    }
                                                </> : null
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-3'>
                                </Col>
                            </Row>

                            <Row>&nbsp;</Row>

                        </>
                }
                <br />


            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>

            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default BookingModule
